import { getPosition } from "./meta-settings.js";
import Swiper from "./plugins/swiper-bundle.esm.browser.min.js";

// Hide and show Header when scroll up
function headerSticky() {
	let prevScrollPos = window.pageYOffset;
	calcHeaderHeight();

	window.onscroll = () => {
		const currentScrollPos = window.pageYOffset;
		calcHeaderHeight();

		if (window.scrollY > 0) {
			if (prevScrollPos > currentScrollPos) {
				header.classList.remove("scrolled");
			} else {
				header.classList.add("scrolled");
			}
		}

		if (window.scrollY === 0) {
			header.classList.remove("scrolled");
		}

		prevScrollPos = currentScrollPos;
	};

	if (window.scrollY !== 0) {
		header.classList.add("scrolled");
	}
}

const header = document.getElementsByClassName(`header`)[0];
// Header scroll
const scrollContainer = () => {
	return document.documentElement || document.body;
};

function calcHeaderHeight() {
	document.documentElement.style.setProperty(
		"--header-height",
		`${
			document.getElementsByClassName("header")[0].getBoundingClientRect()
				.height
		}px`
	);
}

function changeHeightOfHeaderOnAnimation() {
	let timesRun = 0;
	const interval = setInterval(function () {
		calcHeaderHeight();
		timesRun += 1;
		if (timesRun === 300 / 50) {
			clearInterval(interval);
		}
	}, 50);
}

headerSticky();

// if (header.classList.contains("fixed")) {
// 	document.addEventListener("scroll", () => {
// 		if (scrollContainer().scrollTop > 0) {
// 			header.classList.add("scrolled");

// 			changeHeightOfHeaderOnAnimation();
// 		} else if (scrollContainer().scrollTop == 0) {
// 			header.classList.remove("scrolled");

// 			changeHeightOfHeaderOnAnimation();
// 		}
// 	});

// 	calcHeaderHeight();
// }

/*$(".dropdown-toggle").click(function (e) {
	if (isMobileMenuEnable) {
		//close all opened sub menu
		$(".menu-item.dropdown.active .dropdown-menu").slideUp({
			complete: function () {
				$(this).closest(".dropdown").removeClass("active");
			},
		});

		//open current submenu
		$(this).closest(".menu-item.dropdown").toggleClass("active");
		if ($(this).closest(".menu-item.dropdown").hasClass("active")) {
			e.preventDefault();
			$(this).next(".dropdown-menu").slideDown();
		}
	}
});*/

const scrollToTopElement = document.getElementById("scroll-to-top");
const followingCart = document.getElementsByClassName("following-cart")[0];

if (scrollToTopElement) {
	scrollToTopElement.addEventListener("click", function () {
		scrollIntoView(document.getElementById("map"));
	});

	if (!followingCart.classList.contains("sr-only")) {
		scrollToTopElement.classList.add("bottom-[90px]");
		followingCart.style.right = "4vw";
	}

	window.addEventListener("scroll", function () {
		if (window.scrollY > 400) {
			scrollToTopElement.classList.remove(
				"opacity-0",
				"pointer-events-none"
			);
		} else {
			scrollToTopElement.classList.add(
				"opacity-0",
				"pointer-events-none"
			);
		}
	});
}
// menu handlers

const menuToggleElem = document.getElementsByClassName("menu-toggle")[0];
const headerCloseWrapperElem = document.getElementsByClassName(
	"header-close-wrapper"
)[0];

///check mobile menu show/hide condition
const mobileMenuStartPoint = parseInt(
	getComputedStyle(document.documentElement).getPropertyValue(
		"--mobile-menu-start-point"
	)
);
let isMobileMenuEnable =
	window.outerWidth <= mobileMenuStartPoint ||
	document.querySelector(".header-mobile") !== null;

// toggle menu handler
function menuToggle() {
	const menuToggleElements = document.querySelectorAll(".menu-toggle");
	const navbarNavElements = document.querySelectorAll(".navbar-nav");
	const headerCloseWrapperElements = document.querySelectorAll(
		".header-close-wrapper"
	);

	for (let i = 0; i < menuToggleElements.length; i++) {
		menuToggleElements[i].classList.toggle("active");
	}
	for (let i = 0; i < navbarNavElements.length; i++) {
		navbarNavElements[i].classList.toggle("active");
	}
	for (let i = 0; i < headerCloseWrapperElements.length; i++) {
		headerCloseWrapperElements[i].classList.toggle("active");
	}
	header.classList.toggle("active");

	// LockScroll when burger open and enable when closed and enable scroll on menu
	scrollLock.getScrollState()
		? scrollLock.disablePageScroll(
				document.querySelector(".navbar-nav .menu")
		  )
		: scrollLock.enablePageScroll();
}
//menu update function
function updateMenu() {
	isMobileMenuEnable =
		window.outerWidth <= mobileMenuStartPoint ||
		document.querySelector(".mobile-header");
	if (!isMobileMenuEnable) {
		const dropdownMenuElements =
			document.querySelectorAll(".dropdown-menu");
		const headerCloseWrapperElements = document.querySelectorAll(
			".header-close-wrapper"
		);
		const menuItemActiveElements =
			document.querySelectorAll(".menu-item.active");
		const navbarNavElements = document.querySelectorAll(".navbar-nav");
		const menuToggleElements = document.querySelectorAll(".menu-toggle");

		for (let i = 0; i < dropdownMenuElements.length; i++) {
			dropdownMenuElements[i].style.display = "";
		}
		for (let i = 0; i < headerCloseWrapperElements.length; i++) {
			headerCloseWrapperElements[i].classList.remove("active");
		}
		for (let i = 0; i < menuItemActiveElements.length; i++) {
			menuItemActiveElements[i].classList.remove("active");
		}
		for (let i = 0; i < navbarNavElements.length; i++) {
			navbarNavElements[i].classList.remove("active");
		}
		for (let i = 0; i < menuToggleElements.length; i++) {
			menuToggleElements[i].classList.remove("active");
		}
		header.classList.remove("active");

		// LockScroll when burger open and enable when closed
		scrollLock.enablePageScroll();
	}
}

/*$(window).on("resize orientationchange", updateMenu);*/
document.addEventListener("resize", updateMenu);
window.addEventListener("orientationchange", updateMenu);
// end of toggle menu handler

if (menuToggleElem && headerCloseWrapperElem) {
	const menuToggleElements = document.querySelectorAll(".menu-toggle");
	const headerCloseWrapperElements = document.querySelectorAll(
		".header-close-wrapper"
	);

	for (let i = 0; i < menuToggleElements.length; i++) {
		menuToggleElements[i].addEventListener("click", () => {
			menuToggle();
		});
	}

	for (let i = 0; i < headerCloseWrapperElements.length; i++) {
		headerCloseWrapperElements[i].addEventListener("click", () => {
			menuToggle();
		});
	}
}

if (document.getElementsByClassName("aura-card") && window.innerWidth > 1025) {
	const auraCards = document.querySelectorAll(".aura-card");
	const auraCardsCursor = document.querySelectorAll(
		".aura-card .cursor-aura"
	);

	auraCards.forEach((card, i) => {
		const rect = card.getBoundingClientRect();

		const bulletsArr = card.querySelectorAll(".swiper-pagination-bullet");

		card.addEventListener("mousemove", (e) => {
			let x = e.clientX;
			let y = e.clientY;
			auraCardsCursor[
				i
			].style.transform = `translateX(${x}px) translateY(${y}px)`;
		});

		card.addEventListener("mouseenter", (e) => {
			auraCardsCursor[i].classList.add("active");
			card.classList.add("active");

			if (document.querySelector(".banner-btn .btn")) {
				const btnArr = document.querySelectorAll(".banner-btn .btn");
				for (let j = 0; j < btnArr.length; j++) {
					btnArr[j].addEventListener("mouseenter", (ev) => {
						auraCardsCursor[i].classList.remove("active");
						card.classList.remove("active");
					});

					btnArr[j].addEventListener("mouseleave", (ev) => {
						auraCardsCursor[i].classList.add("active");
						card.classList.add("active");
					});
				}
			}
		});

		card.addEventListener("mouseleave", () => {
			auraCardsCursor[i].classList.remove("active");
			card.classList.remove("active");
		});

		window.addEventListener("load", function () {
			const event = new MouseEvent("mouseenter", {
				bubbles: true,
				cancelable: true,
				view: window,
			});
			card.dispatchEvent(event);
		});
	});
}

/**
 * @slider with banners on the main page
 * */
const bannersSlider = document.getElementsByClassName("banners-slider")[0];
if (bannersSlider) {
	const bannersSwiper = new Swiper(".banners-slider", {
		spaceBetween: 0,
		slidesPerView: 1,
		grabCursor: true,

		pagination: {
			el: ".banners-slider .default-heart-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				return `<span class="${className}">
							<svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M19.1271 1.79316C22.7588 1.79316 25.702 4.78177 25.702 8.96581C25.702 17.3339 16.7362 22.1157 13.7476 23.9088C10.759 22.1157 1.79316 17.3339 1.79316 8.96581C1.79316 4.78177 4.78177 1.79316 8.36809 1.79316C10.5916 1.79316 12.5521 2.9886 13.7476 4.18405C14.943 2.9886 16.9035 1.79316 19.1271 1.79316ZM14.8641 20.4468C15.9173 19.7822 16.8677 19.1211 17.7571 18.4134C21.3207 15.5802 23.3111 12.484 23.3111 8.96581C23.3111 6.14457 21.4737 4.18405 19.1271 4.18405C17.8408 4.18405 16.4493 4.86545 15.4379 5.8744L13.7476 7.56475L12.0572 5.8744C11.0459 4.86545 9.65439 4.18405 8.36809 4.18405C6.04893 4.18405 4.18405 6.1637 4.18405 8.96581C4.18405 12.4852 6.17565 15.5802 9.73687 18.4134C10.6275 19.1211 11.5779 19.7822 12.631 20.4456C12.9885 20.6716 13.3423 20.8879 13.7476 21.1294C14.1528 20.8879 14.5067 20.6716 14.8641 20.4468Z" fill="#E63141"/>
								<path d="M14.8641 20.4468C15.9173 19.7822 16.8677 19.1211 17.7571 18.4134C21.3207 15.5802 23.3111 12.484 23.3111 8.96581C23.3111 6.14457 21.4737 4.18405 19.1271 4.18405C17.8408 4.18405 16.4493 4.86545 15.4379 5.8744L13.7476 7.56475L12.0572 5.8744C11.0459 4.86545 9.65439 4.18405 8.36809 4.18405C6.04893 4.18405 4.18405 6.1637 4.18405 8.96581C4.18405 12.4852 6.17565 15.5802 9.73687 18.4134C10.6275 19.1211 11.5779 19.7822 12.631 20.4456C12.9885 20.6716 13.3423 20.8879 13.7476 21.1294C14.1528 20.8879 14.5067 20.6716 14.8641 20.4468Z" fill="white"/>
								<path fill-rule="evenodd" clip-rule="evenodd" d="M13.7476 26L12.825 25.4465C12.6641 25.3499 12.481 25.2421 12.2787 25.1229C10.6832 24.1833 7.89432 22.541 5.41951 20.2076C2.62228 17.5702 0 13.8434 0 8.96581C0 3.8954 3.69057 0 8.36809 0C10.4857 0 12.3507 0.833121 13.7476 1.84037C15.1445 0.833121 17.0094 0 19.1271 0C23.8578 0 27.4952 3.90368 27.4952 8.96581C27.4952 13.8434 24.8729 17.5702 22.0756 20.2076C19.6008 22.541 16.812 24.1833 15.2165 25.1229C15.0141 25.2421 14.831 25.3499 14.6702 25.4465L13.7476 26ZM13.7476 4.18405C14.943 2.9886 16.9035 1.79316 19.1271 1.79316C22.7588 1.79316 25.702 4.78177 25.702 8.96581C25.702 16.8568 17.7294 21.5587 14.3143 23.5729C14.1078 23.6946 13.9179 23.8066 13.7476 23.9088C13.5776 23.8069 13.3883 23.6952 13.1824 23.5738L13.1812 23.573C9.76605 21.5589 1.79316 16.8568 1.79316 8.96581C1.79316 4.78177 4.78177 1.79316 8.36809 1.79316C10.5916 1.79316 12.5521 2.9886 13.7476 4.18405Z" fill="white"/>
							</svg>
						</span>`;
			},
		},

		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},

		mousewheel: {
			forceToAxis: true,
		},
	});
}

/**
 * @slider with featured products
 * */
const productsLikeSlider = document.getElementsByClassName(
	"products-like-slider"
)[0];
if (productsLikeSlider) {
	const productsLikeSlidesArr =
		productsLikeSlider.querySelectorAll(".swiper-slide");
	let loop = true;

	if (productsLikeSlidesArr.length <= 4) {
		loop = false;
	}

	const productsLikeSwiper = new Swiper(".products-like-slider", {
		spaceBetween: 20,
		slidesPerView: 1,
		threshold: 20,
		loop: loop,

		breakpoints: {
			552: {
				slidesPerView: 2,
			},
			770: {
				slidesPerView: 3,
			},
			1026: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
		},

		pagination: {
			el: ".products-like-slider .default-heart-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				return `<span class="${className}">
							<svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M19.1271 1.79316C22.7588 1.79316 25.702 4.78177 25.702 8.96581C25.702 17.3339 16.7362 22.1157 13.7476 23.9088C10.759 22.1157 1.79316 17.3339 1.79316 8.96581C1.79316 4.78177 4.78177 1.79316 8.36809 1.79316C10.5916 1.79316 12.5521 2.9886 13.7476 4.18405C14.943 2.9886 16.9035 1.79316 19.1271 1.79316ZM14.8641 20.4468C15.9173 19.7822 16.8677 19.1211 17.7571 18.4134C21.3207 15.5802 23.3111 12.484 23.3111 8.96581C23.3111 6.14457 21.4737 4.18405 19.1271 4.18405C17.8408 4.18405 16.4493 4.86545 15.4379 5.8744L13.7476 7.56475L12.0572 5.8744C11.0459 4.86545 9.65439 4.18405 8.36809 4.18405C6.04893 4.18405 4.18405 6.1637 4.18405 8.96581C4.18405 12.4852 6.17565 15.5802 9.73687 18.4134C10.6275 19.1211 11.5779 19.7822 12.631 20.4456C12.9885 20.6716 13.3423 20.8879 13.7476 21.1294C14.1528 20.8879 14.5067 20.6716 14.8641 20.4468Z" fill="#E63141"/>
								<path d="M14.8641 20.4468C15.9173 19.7822 16.8677 19.1211 17.7571 18.4134C21.3207 15.5802 23.3111 12.484 23.3111 8.96581C23.3111 6.14457 21.4737 4.18405 19.1271 4.18405C17.8408 4.18405 16.4493 4.86545 15.4379 5.8744L13.7476 7.56475L12.0572 5.8744C11.0459 4.86545 9.65439 4.18405 8.36809 4.18405C6.04893 4.18405 4.18405 6.1637 4.18405 8.96581C4.18405 12.4852 6.17565 15.5802 9.73687 18.4134C10.6275 19.1211 11.5779 19.7822 12.631 20.4456C12.9885 20.6716 13.3423 20.8879 13.7476 21.1294C14.1528 20.8879 14.5067 20.6716 14.8641 20.4468Z" fill="white"/>
								<path fill-rule="evenodd" clip-rule="evenodd" d="M13.7476 26L12.825 25.4465C12.6641 25.3499 12.481 25.2421 12.2787 25.1229C10.6832 24.1833 7.89432 22.541 5.41951 20.2076C2.62228 17.5702 0 13.8434 0 8.96581C0 3.8954 3.69057 0 8.36809 0C10.4857 0 12.3507 0.833121 13.7476 1.84037C15.1445 0.833121 17.0094 0 19.1271 0C23.8578 0 27.4952 3.90368 27.4952 8.96581C27.4952 13.8434 24.8729 17.5702 22.0756 20.2076C19.6008 22.541 16.812 24.1833 15.2165 25.1229C15.0141 25.2421 14.831 25.3499 14.6702 25.4465L13.7476 26ZM13.7476 4.18405C14.943 2.9886 16.9035 1.79316 19.1271 1.79316C22.7588 1.79316 25.702 4.78177 25.702 8.96581C25.702 16.8568 17.7294 21.5587 14.3143 23.5729C14.1078 23.6946 13.9179 23.8066 13.7476 23.9088C13.5776 23.8069 13.3883 23.6952 13.1824 23.5738L13.1812 23.573C9.76605 21.5589 1.79316 16.8568 1.79316 8.96581C1.79316 4.78177 4.78177 1.79316 8.36809 1.79316C10.5916 1.79316 12.5521 2.9886 13.7476 4.18405Z" fill="white"/>
							</svg>
						</span>`;
			},
		},

		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
	});
}

/**
 * @slider double product
 * */
const thumbsSliders = document.getElementsByClassName(`thumbs-slider`)[0];

if (thumbsSliders) {
	/**
	 * @slider for navigation
	 * */
	const thumbsSwiperBottom = new Swiper(".thumbs-slider-bottom", {
		spaceBetween: 12,
		slidesPerView: 4,

		breakpoints: {
			770: {
				spaceBetween: 16,
			},
		},
	});

	/**
	 * @slider product image
	 * */
	const thumbsSwiperTop = new Swiper(".thumbs-slider-top", {
		spaceBetween: 20,
		thumbs: {
			swiper: thumbsSwiperBottom,
		},
	});

	/*	thumbsSwiperBottom.slides.forEach((elem, index) => {
		elem.addEventListener("click", (e) => {
			thumbsSwiperTop.slideTo(index);
		});
	});*/
}

/**
 * @function for floating sidebar
 * */
const contentSticky = document.getElementById("content-sticky");
const rightSidebar = document.getElementById("sidebar");
if (rightSidebar) {
	const sidebarBuffer = rightSidebar.querySelector(".sidebar__buffer");
	const sidebarInner = rightSidebar.querySelector(".sidebar__inner");
	// const headerHeight = +getRootStyle("--header-height").replace("px", "");
	const headerHeight = 0;

	// gap on top and bottom of sticky sidebar
	const gap = 110;

	let lastScrollTop = 0;

	// if flag true === scrolling down else scrolling up
	let flag = null;

	// if flagHeight true === sidebar is higher than viewport height
	let flagHeight =
		document.querySelector(".sidebar__inner").getBoundingClientRect()
			.height >
		window.innerHeight - headerHeight;

	function calcHeightOfSidebar(flag) {
		const contentStickyTop = getPosition(contentSticky).y;
		const sidebarInnerTop = getPosition(sidebarInner).y;
		sidebarBuffer.style.height = `${sidebarInnerTop - contentStickyTop}px`;

		if (flag) {
			// scroll up
			sidebarInner.style.top = "";
			sidebarInner.style.bottom = `${
				-headerHeight -
				gap +
				window.innerHeight -
				sidebarInner.getBoundingClientRect().height
			}px`;
		} else {
			// scroll down
			sidebarInner.style.bottom = "";
			sidebarInner.style.top = `${
				Math.min(
					window.innerHeight -
						sidebarInner.getBoundingClientRect().height,
					headerHeight
				) - gap
			}px`;
		}
		flagHeight =
			sidebarInner.getBoundingClientRect().height >
			window.innerHeight - headerHeight;
	}

	function resetSticky() {
		sidebarInner.style.bottom = "";
		sidebarInner.style.top = `${headerHeight + gap}px`;
		sidebarBuffer.style.height = "0";
	}

	if (!flagHeight) {
		resetSticky();
	} else {
		calcHeightOfSidebar(false);
	}

	window.addEventListener("scroll", function () {
		let st = window.pageYOffset || document.documentElement.scrollTop;

		if (!flagHeight) {
			resetSticky();
		}

		if (st > lastScrollTop && !flag) {
			// scroll down
			calcHeightOfSidebar(flag);
			flag = true;
		} else if (st < lastScrollTop && flag) {
			// scroll up
			calcHeightOfSidebar(flag);
			flag = false;
		}
		lastScrollTop = st <= 0 ? 0 : st;
	});

	window.addEventListener("resize", function (e) {
		if (!flagHeight) {
			resetSticky();
		}

		calcHeightOfSidebar(true);
		calcHeightOfSidebar(false);
	});
}

/**
 * @button to show sidebar on mobile devices
 * */
const btnCategories = document.getElementsByClassName("btn-display-sidebar")[0];
if (btnCategories) {
	const sidebar = document.querySelector(".sidebar");
	const contentList = document.querySelector(".content-transform");
	const pagination = document.querySelector(".pagination");

	function toggleCategoriesMenu() {
		btnCategories.classList.toggle("active");
		sidebar.classList.toggle("active");
		contentList.classList.toggle("active");

		if (pagination) {
			pagination.classList.toggle("active");
		}
	}

	btnCategories.addEventListener("click", () => {
		toggleCategoriesMenu();
	});

	const filtersArr = document.querySelectorAll(".product-category-toggle");
	filtersArr.forEach((filter) => {
		filter.addEventListener("click", () => {
			if (!filter.classList.contains("active")) {
				toggleCategoriesMenu();
			}
		});
	});
}

const productCategoriesFilter = document.getElementsByClassName(
	"product-category-toggle"
)[0];
if (productCategoriesFilter) {
	const filtersArr = document.querySelectorAll(".product-category-toggle");
	for (let i = 0; i < filtersArr.length; i++) {
		filtersArr[i].addEventListener("click", () => {
			for (let j = 0; j < filtersArr.length; j++) {
				if (filtersArr[j].classList.contains("active")) {
					filtersArr[j].classList.remove("active");
				}
			}
			filtersArr[i].classList.add("active");
		});
	}
}

/**
 * @product card and all functionality associated with it
 * */
const productCard = document.getElementsByClassName("product-toggle")[0];
if (productCard) {
	const productCardsArr = document.querySelectorAll(".product-toggle");
	for (let i = 0; i < productCardsArr.length; i++) {
		const favoriteBtn = productCardsArr[i].querySelector(".favorite-btn");
		const input = productCardsArr[i].querySelector("input");

		favoriteBtn.addEventListener("click", () => {
			if (!favoriteBtn.classList.contains("not-logged")) {
				favoriteBtn.classList.toggle("active");
			}
		});

		const counterBlock = productCardsArr[i].querySelector(
			".counter-parent-toggle"
		);
		const btn = productCardsArr[i].querySelector(".btn");

		btn.addEventListener("click", () => {
			if (counterBlock) {
				counterBlock.classList.add("active");
			}

			if (input && input.value < 1) {
				input.stepUp();
			}
		});
	}
}

/**
 * @tabs and all functionality associated with it
 * */
const tabs = document.getElementsByClassName("tabs")[0];
const tabsContent = document.getElementsByClassName("tabs-content")[0];

if (tabs) {
	const tabsArr = document.querySelectorAll(".tabs__item");
	const tabsContentArr = document.querySelectorAll(".tabs-content__item");

	/**
	 * @slider for tabs buttons
	 * */
	const tabsSwiper = new Swiper(".tabs", {
		slidesPerView: "auto",
		slideToClickedSlide: true,
	});

	/**
	 * @function remove active classes for tabs
	 * @param tabs - tabs buttons container
	 * @param content - tabs content container
	 * @param tabsSelector - tabs buttons class
	 * @param contentSelector - tabs content class
	 * */
	function clearTabs(tabs, content, tabsSelector, contentSelector) {
		if (tabs.querySelector(tabsSelector + ".active")) {
			tabs.querySelector(tabsSelector + ".active").classList.remove(
				"active"
			);
		}
		if (content.querySelector(contentSelector + ".active")) {
			content
				.querySelector(contentSelector + ".active")
				.classList.remove("active");
		}
	}

	tabsArr.forEach((tab, i) => {
		tab.addEventListener("click", (e) => {
			clearTabs(tabs, tabsContent, ".tabs__item", ".tabs-content__item");
			tab.classList.add("active");
			tabsContentArr[i].classList.add("active");
		});
	});
}

if (document.getElementsByClassName("password-input"[0])) {
	const passwordInputArr = document.querySelectorAll(".password-input");
	for (let i = 0; i < passwordInputArr.length; i++) {
		const input = passwordInputArr[i].querySelector("input");
		const btn = passwordInputArr[i].querySelector(".show-btn");

		btn.addEventListener("click", () => {
			if (input.type === "password") {
				input.type = "text";
				btn.classList.add("active");
			} else {
				input.type = "password";
				btn.classList.remove("active");
			}
		});
	}
}

const phoneNumberInput = document.getElementsByClassName("phone-input")[0];

if (phoneNumberInput) {
	const phoneNumberInputArr = document.querySelectorAll(".phone-input");

	const maskOptions = {
		mask: "+{38}0000000000",
	};

	const validatePhoneNumberLength = (value) => {
		return value.replace(/\D/g, "").length === 12;
	};

	const formatPhoneNumberInput = (input) => {
		const currentValue = input.value;
		const infoInput = input.parentElement.querySelector(".input-info");

		if (validatePhoneNumberLength(currentValue)) {
			if (Number(input.value[3]) !== 0) {
				infoInput.classList.add("active");
				infoInput.classList.remove("active-valid");
				infoInput.classList.add("active-not-valid");
				infoInput.textContent =
					"Код оператору має починатися з 0, наприклад 099";
			} else {
				infoInput.classList.add("active");
				infoInput.classList.remove("active-not-valid");
				infoInput.classList.add("active-valid");
				infoInput.textContent = "Номер телефону введено коректний";
				setTimeout(function () {
					infoInput.classList.remove("active");
				}, 2000);
			}
		} else {
			infoInput.classList.add("active");
			infoInput.classList.remove("active-valid");
			infoInput.classList.add("active-not-valid");
			infoInput.textContent =
				"Введіть коректний номер телефону, має бути 12 символів";
		}
	};

	phoneNumberInputArr.forEach((input, index) => {
		const mask = IMask(input, maskOptions);

		input.addEventListener("input", (event) => {
			formatPhoneNumberInput(event.target);
		});
	});
}

const cartList = document.querySelector("#cart-list");

if (cartList) {
	const deskParent = document.querySelector(".order-cart");
	const mobParent = document.querySelector(".cart-list-for-mobile");

	function moveBlockParent() {
		const cartList = document.querySelector("#cart-list");
		if (window.innerWidth <= 769) {
			mobParent.appendChild(cartList);
		} else {
			deskParent.insertBefore(cartList, deskParent.firstChild);
		}
	}

	if (window.innerWidth < 769) {
		moveBlockParent();
	}

	window.addEventListener("resize", moveBlockParent);
}

// Pass single element

window.initChoices = function initChoices() {
	const choicesDOM = document.querySelector(".default-choices-select");
	if (choicesDOM) {
		const choicesDOMArr = document.querySelectorAll(
			".default-choices-select"
		);
		for (let i = 0; i < choicesDOMArr.length; i++) {
			if (!choicesDOMArr[i].classList.contains("is-start")) {
				choicesDOMArr[i].classList.add("is-start");
				new Choices(choicesDOMArr[i], {
					searchEnabled: true,
					itemSelectText: "",
					placeholder: true,
					allowHTML: true,

					fuseOptions: {
						threshold: 0.3,
					},
					noResultsText: "Нічого не знайдено",
				});
			}
		}
	}
};
initChoices();

const inputClear = document.getElementsByClassName("input-with-clear")[0];
if (inputClear) {
	const input = inputClear.querySelector("input");
	const btn = inputClear.querySelector(".btn-clear");
	const targetButton = document.getElementById("search-form-btn");

	if (input.value !== "") {
		btn.classList.add("active");
	}

	input.addEventListener("input", () => {
		if (input.value !== "") {
			btn.classList.add("active");
		} else {
			btn.classList.remove("active");
		}
	});

	btn.addEventListener("click", () => {
		input.value = "";
		input.setAttribute("value", "");
		btn.classList.remove("active");
		targetButton.click();
	});
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);

// We listen to the resize event
window.addEventListener("resize", () => {
	// We execute the same script as before
	vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
	document.documentElement.style.setProperty(
		"--header-height",
		`${
			document.getElementsByClassName("header")[0].getBoundingClientRect()
				.height
		}px`
	);
});

var elements = document.querySelectorAll(".force-sticky");
Stickyfill.forceSticky();
Stickyfill.add(elements);

/*const howToDeliverContainer = document.getElementById("how-to-deliver");
if (howToDeliverContainer) {
	const deliverSelfPickupInputArr =
		howToDeliverContainer.querySelectorAll("input");
	const deliverSelfPickupInput = document.getElementById(
		"deliver-self-pickup"
	);
	const notSelfPickupElements = document.querySelectorAll(".not-self-pickup");
	const selfPickupElements = document.querySelectorAll(".for-self-pickup");

	/!**
	 * @function that hides all elements with the 'not-self-pickup' class if the self-display option is selected
	 * *!/
	function hiddenNotSelfPickupElements() {
		for (let i = 0; i < notSelfPickupElements.length; i++) {
			notSelfPickupElements[i].classList.add("sr-only");
		}
		for (let i = 0; i < selfPickupElements.length; i++) {
			selfPickupElements[i].classList.remove("sr-only");
		}
	}

	/!**
	 * @function a function that returns all hidden elements with the 'not-self-pickup' class if the self-display option is selected
	 * *!/
	function removeHiddenNotSelfPickupElements() {
		for (let i = 0; i < notSelfPickupElements.length; i++) {
			notSelfPickupElements[i].classList.remove("sr-only");
		}
		for (let i = 0; i < selfPickupElements.length; i++) {
			selfPickupElements[i].classList.add("sr-only");
		}
	}

	if (deliverSelfPickupInput.checked) {
		hiddenNotSelfPickupElements();
	} else {
		removeHiddenNotSelfPickupElements();
	}

	deliverSelfPickupInputArr.forEach((radioInput) => {
		radioInput.addEventListener("change", () => {
			if (deliverSelfPickupInput.checked) {
				hiddenNotSelfPickupElements();
			} else {
				removeHiddenNotSelfPickupElements();
			}
		});
	});
}*/

if (document.getElementsByClassName("decor-path")[0]) {
	const decors = document.querySelectorAll(".decor-path path");
	function getPathLength(figure) {
		figure.forEach((elem) => {
			elem.style.strokeDasharray = `${elem.getTotalLength()}`;
			elem.style.strokeDashoffset = `${elem.getTotalLength()}`;
		});
	}
	getPathLength(decors);
}

if (
	document.getElementsByClassName("franchise-start-section__item-circle")[0]
) {
	const parentSVG = document.querySelectorAll(
		".franchise-start-section__item-circle svg"
	);
	parentSVG.forEach((parentSVG, index) => {
		const childPaths = parentSVG.querySelectorAll("path");

		const selectedItems = Array.from(childPaths).slice(0, index + 1);

		selectedItems.forEach((item, i) => {
			item.classList.add(`item-path-${index + 1}`);
			if (!item.classList.contains("big-hearth")) {
				if (i >= 9) {
					console.log(i);
					item.style.transitionDelay = `1.1${i + 1}9s`;
				} else {
					item.style.transitionDelay = `0.${i + 1}9s`;
				}
			}
		});
	});
}

const scrollEvents = () => {
	const trueScrollTarget =
		document.getElementsByClassName("scroll-target")[0];

	if (trueScrollTarget) {
		const scrollTarget = document.querySelectorAll(".scroll-target");
		let threshold = 0.5;
		let decorsArr = [];

		if (document.getElementsByClassName("scroll-decor")[0]) {
			decorsArr = document.querySelectorAll(".scroll-decor");
		}

		if ("IntersectionObserver" in window) {
			console.log("IntersectionObserver is supported");
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry, i) => {
						if (entry.isIntersecting) {
							if (decorsArr.length !== 0) {
								decorsArr.forEach((elem, i) => {
									if (entry.target === elem) {
										elem.classList.add("animation");

										if (
											entry.target.querySelector(
												".big-hearth"
											)
										) {
											setTimeout(function () {
												elem.classList.add(
													"animation-end"
												);
												setTimeout(function () {
													elem.classList.add(
														"animation-pulse"
													);
												}, 900);
											}, 1250);
										}
									}
								});
							}
						}
					});
				},
				{
					threshold: 0,
					rootMargin: "0% 0% -10% 0%",
				}
			);

			scrollTarget.forEach((target, index) => {
				observer.observe(target);
			});
		} else {
			console.log("IntersectionObserver doesn't supported!");
		}
	}
};

scrollEvents();

if (document.querySelector('[id^="pin-toggle-"]')) {
	const toggleButtons = document.querySelectorAll('[id^="pin-toggle-"]');

	toggleButtons.forEach((button) => {
		const city = button.id.replace("pin-toggle-", "");
		const correspondingMapItem = document.getElementById(`pin-map-${city}`);

		button.addEventListener("mouseenter", () => {
			correspondingMapItem.classList.add("active");
		});

		button.addEventListener("mouseleave", () => {
			correspondingMapItem.classList.remove("active");
		});
	});
}

window.loaderBtnStart = function loaderBtnStart(btn) {
	btn.innerHTML = `<span class="opacity-0 flex">${btn.innerHTML}</span>`;

	btn.insertAdjacentHTML(
		"beforeend",
		`
		<div role="status" class="absolute inset-0 flex items-center justify-center">
			<svg aria-hidden="true" class="inline w-6 h-6 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
					<path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
			</svg>
			<span class="sr-only">Завантаження...</span>
		</div>
	`
	);

	btn.classList.add("disabled");
	btn.disabled = true;
};

window.loaderBtnEnd = function loaderBtnEnd(id) {
	const btn = document.getElementById(id);

	btn.querySelector('div[role="status"]').remove();
	btn.innerHTML = btn.querySelector("span.opacity-0").innerHTML;

	btn.classList.remove("disabled");
	btn.disabled = false;
};

window.globalLoaderStart = function globalLoaderStart() {
	const loader = document.getElementById("global-loader");

	loader.classList.remove("pointer-events-none", "opacity-0");
	loader.classList.add("opacity-100");
	scrollLock.disablePageScroll();
};

window.globalLoaderEnd = function globalLoaderEnd() {
	const loader = document.getElementById("global-loader");

	loader.classList.remove("opacity-100");
	loader.classList.add("pointer-events-none", "opacity-0");
	scrollLock.enablePageScroll();
};

window.decreaseInputNumber = function decreaseInputNumber(inputId) {
	const input = document.getElementById(inputId);
	input.stepDown();

	const parentBlock = input.closest(".counter-parent-toggle");
	if (Number(input.value) === 0 && parentBlock.classList.contains("active")) {
		parentBlock.classList.remove("active");
	}

	const event = new Event("change");
	input.dispatchEvent(event);
};

window.increaseInputNumber = function increaseInputNumber(inputId) {
	const input = document.getElementById(inputId);
	input.stepUp();

	const event = new Event("change");
	input.dispatchEvent(event);
};

window.checkInputNumber = function checkInputNumber(inputId) {
	const input = document.getElementById(inputId);

	if (input.value < 1) {
		input.stepUp();
	}
};

const allElementsWithApproveClick = Array.from(
	document.querySelectorAll("[\\@click]")
);
if (allElementsWithApproveClick.length) {
	allElementsWithApproveClick.forEach((elem) => {
		elem.addEventListener("click", function (ev) {
			ev.preventDefault();

			Swal.fire({
				title: "<span class='text-blue'>Ви впевнені що хочете видалити продукт з корзини?</span>",
				// text: "You won't be able to revert this!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#5daa3c",
				cancelButtonColor: "#e52139",
				confirmButtonText: "Так, видалити!",
				cancelButtonText: "Відмінити",
			}).then((result) => {
				if (result.isConfirmed) {
					eval(elem.getAttribute("@click"));
					// Swal.fire(
					// 	"Видалено!",
					// 	"Товар успішно видалено з корзини.",
					// 	"success"
					// );
				}
			});
		});
	});
}

const allCheckoutInputs = Array.from(
	document.getElementsByClassName("checkout-input")
);
if (allCheckoutInputs.length) {
	allCheckoutInputs.forEach((input) => {
		input.addEventListener("keydown", function (evt) {
			if (evt.key === "Enter") {
				input.blur();
			}
		});

		input.addEventListener("input", function () {
			if (input.value >= 100) {
				input.classList.add("w-[40px]");
			} else {
				input.classList.remove("w-[40px]");
			}
		});

		if (input.value >= 100) {
			input.classList.add("w-[40px]");
		} else {
			input.classList.remove("w-[40px]");
		}
	});
}

window.addEventListener("load", function () {
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has("keywords")) {
		scrollToEl("#search_results_box|500");
	}
});

window.initializeProductToggle = function initializeProductToggle() {
	const productCard = document.getElementsByClassName("product-toggle")[0];
	if (productCard) {
		const productCardsArr = document.querySelectorAll(".product-toggle");
		for (let i = 0; i < productCardsArr.length; i++) {
			const favoriteBtn =
				productCardsArr[i].querySelector(".favorite-btn");
			const input = productCardsArr[i].querySelector("input");

			favoriteBtn.addEventListener("click", () => {
				if (!favoriteBtn.classList.contains("not-logged")) {
					favoriteBtn.classList.toggle("active");
				}
			});

			const counterBlock = productCardsArr[i].querySelector(
				".counter-parent-toggle"
			);
			const btn = productCardsArr[i].querySelector(".btn");

			btn.addEventListener("click", () => {
				if (counterBlock) {
					counterBlock.classList.add("active");
				}

				if (input && input.value < 1) {
					input.stepUp();
				}
			});
		}
	}
};

const wheel = document.querySelector(".bfp");

if (wheel) {
	const openBtn = document.querySelector("#bf-open");
	openBtn.addEventListener("click", () => wheel.classList.add("is-show"));

	if (localStorage.getItem("bf-wheel") !== "true") {
		wheel.classList.add("is-show");
		localStorage.setItem("bf-wheel", "true");
	}

	const closeBtn = wheel.querySelector(".bfp__close-btn");

	closeBtn.addEventListener("click", () => wheel.classList.remove("is-show"));
	wheel.addEventListener("click", ({ target }) => {
		if (
			target.classList.contains("bfp") ||
			target.classList.contains("bfp__wrap") ||
			target.classList.contains("bfp__content-wrap")
		)
			wheel.classList.remove("is-show");
	});

	window.openBlackFridayPopup = function openBlackFridayPopup() {
		wheel.classList.add("is-show");
	};
	// infoWrap.addEventListener("click", (e) => e.stopPropagation());

	const wheelItemsWrap = wheel.querySelector(".bfp__wheel-item-list");
	const itemList = wheel.querySelectorAll(".bfp__wheel-item");
	const startBtn = wheel.querySelector(".wheel-start");
	const centerStartBtn = wheel.querySelector(".bfp__wheel-button");
	const phoneNumberWrap = wheel.querySelector("#black-friday-phone-number");
	const phoneNumberInput = phoneNumberWrap.querySelector("input");
	const phoneNumberInfo = phoneNumberWrap.querySelector(".input-info");
	const boxText = wheel.querySelector(".bfp__wheel-prize-text");
	const prizeInfoText = wheel.querySelector(".bfp__info-prize-text");
	const prizeImg = wheel.querySelector(".bfp__wheel-prize-bg");

	phoneNumberInput.addEventListener("input", () => {
		if (phoneNumberInfo.classList.contains("active-not-valid")) {
			startBtn.disabled = true;
			centerStartBtn.disabled = true;
		} else {
			startBtn.disabled = false;
			centerStartBtn.disabled = false;
		}
	});

	const sectorPercent = 100 / itemList.length;
	const sectorDegree = 360 / itemList.length;
	const deviationDegree = 90 - sectorDegree;
	const animationDelay = 5000;

	const positionCalculate = [...itemList].reduce(
		(acc, item, idx) => {
			acc.itemRotateResult.push(
				acc.degree + sectorDegree / 2 - deviationDegree
			);
			acc.degree += sectorDegree;
			acc.percent += sectorPercent;

			const color = idx % 2 ? "#F9F8FD" : "#E7364C";
			const gradientSector = `${color} 0, ${color} ${acc.percent}% ${
				idx !== itemList.length - 1 ? ", " : ""
			}`;

			acc.gradientResult += gradientSector;

			return acc;
		},
		{
			percent: 0,
			degree: 0,
			gradientResult: "",
			itemRotateResult: [],
		}
	);

	positionCalculate.itemRotateResult.forEach((item, idx) => {
		itemList[idx].style.transform = `translateY(-50%) rotate(${item}deg)`;
	});

	wheelItemsWrap.style.background = `radial-gradient(circle closest-side, transparent 100%, white 0), conic-gradient(${positionCalculate.gradientResult})`;

	wheelItemsWrap.style.transform = `rotate(${deviationDegree}deg)`;

	const animateWheel = async () => {
		const response = await window.loadWithResponse(
			"page/carousel",
			`tel=${phoneNumberInput.value}`
		);

		if (response.error) {
			phoneNumberInfo.classList.add("active");
			phoneNumberInfo.classList.remove("active-valid");
			phoneNumberInfo.classList.add("active-not-valid");
			phoneNumberInfo.textContent = response.error;

			return;
		}

		startBtn.disabled = true;
		centerStartBtn.disabled = true;
		phoneNumberInput.disabled = true;

		const giftItemIdx = [...itemList].findIndex(
			(item) => item.dataset.id === String(response.id)
		);

		wheel.classList.add("animating");

		wheelItemsWrap.style.transition = `transform ease-out ${animationDelay}ms`;

		// card_content: "Знижка 20%";
		// id: 1;
		// prize_image: "/app/data/presents/1/1/crop_7b4da233fd5679b9619241070220e8a9.jpg";
		// title: "Знижка 20%";

		const titleHTML = formatFirstWordWithSpan(response.title);

		boxText.innerHTML = titleHTML;
		prizeInfoText.innerHTML = titleHTML;
		prizeImg.src = response.prize_image;

		wheelItemsWrap.classList.add("animate");
		wheelItemsWrap.style.transform = `rotate(${
			7 * 360 -
			giftItemIdx * sectorDegree -
			sectorDegree / 2 +
			deviationDegree +
			getRandomArbitrary(-sectorDegree / 4, sectorDegree / 4)
		}deg)`;

		const confettiEl = document.querySelector("#confetti");

		setTimeout(() => {
			wheel.classList.add("wheel-rotate-finished");
			wheel.classList.remove("animating");
		}, animationDelay + 500);

		setTimeout(() => {
			const rect = confettiEl.getBoundingClientRect();

			const defaults = {
				spread: 360,
				ticks: 100,
				gravity: 0,
				decay: 0.94,
				position: {
					x: ((rect.x + rect.width / 2) * 100) / window.innerWidth,
					y: ((rect.y + rect.height / 2) * 100) / window.innerHeight,
				},
				startVelocity: 30,
				shapes: ["circle", "square", "tringle", "polygon"],
				colors: ["e63041", "ffffff"],
			};

			confetti({
				...defaults,
				particleCount: 350,
				scalar: 0.5,
			});

			confetti({
				...defaults,
				particleCount: 200,
				scalar: 1,
			});

			confetti({
				...defaults,
				particleCount: 30,
				scalar: 1.5,
			});

			if (document.getElementById("to_door")) {
				window.changeToDoor();
			}
		}, animationDelay + 1050);
	};

	startBtn.addEventListener("click", animateWheel);
	centerStartBtn.addEventListener("click", animateWheel);

	// Timer
	const timerWrap = wheel.querySelector(".bfp__info-end-timer");
	const days = timerWrap.querySelector("#days");
	const hours = timerWrap.querySelector("#hours");
	const minutes = timerWrap.querySelector("#minutes");
	const seconds = timerWrap.querySelector("#seconds");

	const { endDate } = timerWrap.dataset;

	const timerId = setInterval(() => {
		if (endDate - Date.now() <= 0) {
			days.textContent = "00";
			hours.textContent = "00";
			minutes.textContent = "00";
			seconds.textContent = "00";

			return clearInterval(timerId);
		}

		const separatedDate = convertMilliseconds(endDate - Date.now());

		days.textContent = addLeadingZero(separatedDate.days);
		hours.textContent = addLeadingZero(separatedDate.hours);
		minutes.textContent = addLeadingZero(separatedDate.minutes);
		seconds.textContent = addLeadingZero(separatedDate.seconds);
	}, 1000);




}
// Utils funcs for wheel logic
function convertMilliseconds(milliseconds) {
	const seconds = Math.floor(milliseconds / 1000);
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	const remainingHours = hours % 24;
	const remainingMinutes = minutes % 60;
	const remainingSeconds = seconds % 60;

	return {
		days: days,
		hours: remainingHours,
		minutes: remainingMinutes,
		seconds: remainingSeconds,
	};
}

function addLeadingZero(number) {
	return String(number).padStart(2, "0");
}

function getRandomArbitrary(min, max) {
	return Math.random() * (max - min) + min;
}

function formatFirstWordWithSpan(inputString) {
	const words = inputString.split(" ");
	const firstWord = words.shift();
	const restOfText = words.join(" ");
	console.log("words", words);
	const formattedString = words.length
		? `<span>${firstWord}</span><span class="accent">${restOfText}</span>`
		: `<span class="accent">${firstWord}</span>`;

	return formattedString;
}

const chatToggleBtn = document.getElementsByClassName('following-chat-btn')[0];
const chatModal = document.getElementsByClassName('chat-modal')[0];

if (chatToggleBtn && chatModal) {
	/*const vh = window.innerHeight * 0.01;*/

	const chatModalClose = chatModal.querySelector('.chat-modal__head-close');
	const chatModalScrollEl = chatModal.querySelector('.chat-modal__scroll');

	const chatInput = chatModal.querySelector('.chat-modal__input-container input');
	const chatTextarea = chatModal.querySelector('.chat-modal__input-container textarea');
	const chatInputBtn = chatModal.querySelector('.chat-modal__input-btn');

	/*const chatModalHeadEl = chatModal.querySelector('.chat-modal__head');
	const chatModalBottomlEl = chatModal.querySelector('.chat-modal__bottom');
	const headerEl = chatModal.querySelector('header');*/

	chatToggleBtn.addEventListener('click', (event) => {
		event.stopPropagation();
		chatModal.classList.remove('is-closed');
		chatModal.classList.toggle('is-active');
	});

	chatModalClose.addEventListener('click', () => {
		chatModal.classList.add('is-closed');

		setTimeout(function () {
			chatModal.classList.remove('is-active');
		}, 400);

		setTimeout(function () {
			chatModal.classList.remove('is-closed');
		}, 900);
	})

	document.addEventListener('click', (event) => {
		const targetElement = event.target;
		const isChatOpen = chatModal.classList.contains('is-active');

		if (isChatOpen && !chatModal.contains(targetElement) && targetElement !== chatToggleBtn) {
			chatModal.classList.remove('is-active');
		}
	});

	const chatModalScroll = new SimpleBar(chatModalScrollEl);

	window.scrollToBottom = function scrollToBottom () {
		const scrollContainer = chatModalScroll.getScrollElement();
		if (scrollContainer) {
			const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

			if (isSmoothScrollSupported) {
				scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior: 'smooth' });
			} else {
				scrollContainer.scrollTop = scrollContainer.scrollHeight;
			}
		}
	}

	if(chatInput) {
		chatInput.addEventListener('change', () => {
			scrollToBottom();
		})
	}

	if(chatTextarea) {
		chatTextarea.addEventListener('change', () => {
			scrollToBottom();
		})
	}

	chatInputBtn.addEventListener('click', () => {
		scrollToBottom();
	})
}

window.initChatProductToggle = function initChatProductToggle() {
	const productCard = document.getElementsByClassName("chat-bot-message__product")[0];
	if (productCard) {
		const productCardsArr = document.querySelectorAll(".chat-bot-message__product");
		for (let i = 0; i < productCardsArr.length; i++) {
			const input = productCardsArr[i].querySelector("input");

			const counterBlock = productCardsArr[i].querySelector(
					".counter-parent-toggle"
			);
			const btn = productCardsArr[i].querySelector(".chat-bot-btn");

			if(btn) {
				btn.addEventListener("click", () => {
					if (counterBlock) {
						counterBlock.classList.add("active");
					}

					if (input && input.value < 1) {
						input.stepUp();
					}
				});
			}
		}
	}
};
initChatProductToggle();

